// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quEmf7iby8BXeRKio4GA {
  display: flex;
  align-items: center;
  gap: 0.6em;
  padding: 0.4em 1em 0.4em 0.4em;
  background-color: var(--bar-background);
}
.quEmf7iby8BXeRKio4GA > div {
  flex: 100% 1 1;
  display: flex;
  background-color: var(--background);
  padding: 0.2em 0.6em 0.2em 0.3em;
  border-radius: var(--dry-border-radius);
}
.quEmf7iby8BXeRKio4GA > div > i {
  flex: 1em 0 0;
  color: var(--bar-color);
  font-size: 1.3em;
  margin-top: 0.1em;
  opacity: 0.6;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf {
  flex: 100% 1 1;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf button {
  flex: 1em 0 0;
  display: flex;
  font-size: 0.7rem;
  border-radius: 2px;
  padding: 0.1em 0.4em;
  opacity: 0.8;
  cursor: pointer;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf button:hover {
  background-color: var(--hover-background);
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf button[data-on="true"] {
  background-color: var(--selected-background);
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf button > .icon {
  font-size: 1.4em;
  line-height: 1.1em;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .SAZBshKkqC1vfPMG87rS {
  flex: 100% 1 1;
  display: flex;
  align-items: center;
  gap: 0.2em;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .SAZBshKkqC1vfPMG87rS > input {
  flex: 100% 1 1;
  background-color: var(--background);
  font-size: 0.9rem;
  border: 1px solid transparent;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .SAZBshKkqC1vfPMG87rS > input::placeholder {
  font-weight: 300;
  opacity: 0.6;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .SAZBshKkqC1vfPMG87rS[data-error="true"] > input {
  color: var(--dry-error-text);
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O {
  margin-top: 0.4em;
  font-size: 0.9em;
  display: flex;
  align-items: center;
  gap: 0.2em;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O button {
  display: flex;
  gap: 0.2em;
  padding: 0 0.2em;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O > i {
  opacity: 0.3;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O ._iULeRbGf3pwixVjB2QI {
  flex: 100% 1 1;
  justify-content: right;
  border-radius: 2px;
  display: flex;
  gap: 0.2em;
  align-items: center;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O ._iULeRbGf3pwixVjB2QI > i {
  opacity: 0.3;
}
.quEmf7iby8BXeRKio4GA > div .UJhi44HBi6Vvj65c8eIf .eVCcuX6qaQb3d0DUEO4O ._iULeRbGf3pwixVjB2QI > button {
  border-radius: 2px;
  padding: 0em 0.4em;
  white-space: nowrap;
}
.quEmf7iby8BXeRKio4GA > button {
  flex: 1em 0 0;
  color: var(--bar-color);
  cursor: pointer;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `quEmf7iby8BXeRKio4GA`,
	"filter": `UJhi44HBi6Vvj65c8eIf`,
	"icon": `icon`,
	"name": `SAZBshKkqC1vfPMG87rS`,
	"other": `eVCcuX6qaQb3d0DUEO4O`,
	"git": `_iULeRbGf3pwixVjB2QI`
};
export default ___CSS_LOADER_EXPORT___;
